<template>
  <div
    v-show="$router.history.current.query.lang"
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
    style="background: #002140;"
  >
    <notifications></notifications>
    <top-navbar
      @changeName="clickMenu"
      @changeDatabase= "changeDatabase" 
      @changeSys="changeUserSys"
      :name= "this.menuName"
      :sys ="UserInfo.sys"
      :role="UserInfo ?UserInfo.role_id :-1" 
      @useOtherOrgani="id => sel_organi = id"
      :organi="organi"
    />
    <side-bar
      :style="{'margin-top': top_nav_height, 'box-shadow': 'none'}"
      :active-color="sidebarBackground"
      :data-background-color="sidebarBackgroundColor"
    >
      <mobile-menu 
        @changeName="clickMenu"
        @changeDatabase= "changeDatabase" 
        @changeSys="changeUserSys"
        :organi="JSON.stringify(organi) === '[{}]' ?[] :organi"
        :name= "this.menuName"
        :sys ="UserInfo.sys"
        :role="UserInfo ?UserInfo.role_id :-1" 
      ></mobile-menu>
      <template slot="links">
        <!-- 首页 -->
        <sidebar-item
          :otherClickFunc ="clickMenu"
          :link="{ name: this.$I18n('index_home'), custom_icon: true, path: '/home' + `?lang=${$router.history.current.query.lang}`}"
        >
          <template slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/home.svg"></object>
          </template>
        </sidebar-item>
        <sidebar-item 
          v-for="mainItem in menuList" 
          :key="mainItem.menu_key" 
          :link="{
            collapsed: !isShow(mainItem),
            name : mainItem.menu_name , 
            icon : menuInfo.main[mainItem.menu_key].icon,
            custom_icon: menuInfo.main[mainItem.menu_key].custom,
          }"
        >
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'personnel'" slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/personnel.svg"></object>
          </template>
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'device'" slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/device.svg"></object>
          </template>
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'approvel'" slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/approvel.svg"></object>
          </template>
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'organization'" slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/organization.svg"></object>
          </template>
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'access_control'" slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/access_control.svg"></object>
          </template>
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'account'" slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/account.svg"></object>
          </template>
          <template v-if="menuInfo.main[mainItem.menu_key].icon === 'log_queries'" slot="icon">
            <object class="menu-custom-icon" type="image/svg+xml" data="/icon/log_queries.svg"></object>
          </template>
          <sidebar-item
            v-for= "subItem in mainItem.sub_menus"
            :otherClickFunc ="clickMenu"
            :key = "subItem.menu_key"
            :actived = "isActived(subItem)"
            :link="{
              hide : true,
              name : subItem.menu_name,
              path : menuInfo.sub[subItem.menu_key] + `?lang=${$router.history.current.query.lang}`,
            }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    
    <div class="main-panel" :style="{'background-color':'rgb(243,248,255)','min-height': 'calc(100vh - 193px)','max-height': 'calc(100vh - '+ top_nav_height +')'}">
      <div
        :class="{ content: !$route.meta.hideContent , 'diy-body' : $root.state.mobile }"
        style="padding-top: 10px;padding-right: 0; padding-bottom: 0px;padding-left: 10px;"
        @click="toggleSidebar"
      >
        <md-card style="margin-bottom: 0;margin-top: 0;border-top-right-radius: 0;border-bottom-right-radius: 0;z-index: 0;">
          <md-card-content>
            <div style="line-height: 30px;height: 30px;">
              <md-icon>chevron_left</md-icon>
              <p style="font-size: 13px; font-weight: 400;display: inline-block;margin: 0;">{{$I18n(this.$router.history.current.name)}}</p>
            </div>
          </md-card-content>
        </md-card>
        <!-- 主题  -->
        <zoom-center-transition v-if="UserInfo.id" :duration="200" mode="out-in" style="margin-right: 15px;">
          <!-- your content here v-if="user_sys && user_database"  -->
          <router-view 
            :key="sel_organi" 
            :userinfo_sys="user_sys" 
            :userinfo_database="user_database"
            :sel_organi="sel_organi"
            :organi="organi"
            @reget_organi="regetOrgani">
          </router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      <simple-modal 
        ref    = "modal"
        :title = "$I18n('inst_info_1')"
        :always= "organi.length === 0"
        @submit= "modal_submit"
        @close = "close_modal"
      >
        <template slot="body">
          <!-- 表单-修改/添加菜单表单 -->
          <common-form-item 
            style="margin-bottom: 16px;"
            :labelweight="160"
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <template slot="icon">
              <image-select :path="modalData.Form.icon" @updatePath="value => modalData.Form.icon = value" :file_type="['jpge','jpg','png']" :file_size_mb="8"/>
            </template>
          </common-form-item>
        </template>
      </simple-modal>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "/public/font/iconfont.css"
import menu from "/public/ucfg/menu.js"
// import "/public/font/iconfont.js"

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
// import FixedPlugin from "../../FixedPlugin.vue";
// import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { FormClass } from "@/common/tools.js";

// 国家、城市
import c_en from "/public/ucfg/countries_en.json";
import c_cn from "/public/ucfg/countries_en.json";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    ZoomCenterTransition,
    // FixedPlugin,
    // UserMenu,
  },
  data() {
    let modalData = new FormClass({ // 弹窗-表单数据
      name   : {
        init    : parseInt(new Date().getTime()/1000) + "",
        check   : "smallstr",
        errormsg: this.$I18n("inst_info_3"),
      },
      industry  : "",
      scale     : "",
      country   : "",
      addr      : {
        init    : "",
        check   : "smallstr",
        errormsg: this.$I18n("full_addr_len"),
      },
      dept_name : "",
      icon      : "",
    });
    modalData.Errmsgsort = ["name", "addr"];

    return {
      sel_organi: "",
      top_nav_height: "60px",

      user_sys: "",
      user_database: "",
      menuName : this.$I18n("index_home"),
      menuList : [],
      sidebarBackgroundColor: "diy",
      sidebarBackground: "diy",
      sidebarBackgroundImage: "./img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      menuInfo : {
        main: {...menu.main},
        sub : {...menu.sub},
      },

      modalData,
      countrys : this.$router.history.current.query.lang === "zh-CN" ?c_cn :c_en,
      organi: [{}],
    };
  },
  methods: {
    isShow(menu){
      if(!this.$router || !this.$router.history.current || !menu || !menu.sub_menus){
        return false
      }
      return menu.sub_menus.some(i => this.$router.history.current.fullPath.includes(`${this.menuInfo.sub[i.menu_key]}?`))
    },
    isActived(subItem){
      if(!this.$router || !this.$router.history.current || !subItem){
        return false
      }
      return this.$router.history.current.fullPath.includes(`${this.menuInfo.sub[subItem.menu_key]}?`)
    },
    // 关闭弹窗-添加机构表单
    close_modal(){
      this.getOrgani()
        .then(() => {
          // 放弃创建机构 => 跳回登录
          if(this.organi.length === 0){
            this.$setUserInfo({})
            this.setMenu([])
            this.$gopage("/login")
          }
          // 正常登录完成
        })
    },
    // 提交-添加机构表单
    modal_submit(){
      if(this.modalData.Check()){
        this.$errorMsg(this.modalData.ErrMsg ?this.modalData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.a_Organi({
        ...this.modalData.Form,
        dept_name : "Default Department",
        loc_name: "Default area",
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.$refs.modal.close();
        }))
        .catch(err => {
          if(err.code === 8010){
            this.$errorMsg(this.$I18n("error_code_8010"))
          } else {
            this.$errorMsg(this.$I18n("add_fail") + `[${err.code}]`)
          }
        })
    },
    // 查询机构
    getOrgani(){
      return this.$api.g_Organi({
         get_menu:1,
         get_dept:1,
      })
        .then(res => {
          this.organi = res.data;
          if(res.data.length > 0){
            this.sel_organi = res.data[0].id;
            this.$setUserInfo(res.data[0]);
            this.setMenu(res.data[0].sys_menus)
          }
        })
    },
    // 重新查询机构数据(但不更新 set_organi状态)
    regetOrgani(){
      return this.$api.g_Organi({
         get_menu:1,
         get_dept:1,
      })
        .then(res => {
          this.organi = res.data;
          if(res.data.length > 0){
            var org = res.data.filter(i => i.id === this.sel_organi)[0]
            if(org){
              this.$setUserInfo(org);
              this.setMenu(org.sys_menus);
            }
          }
        })
    },
    // 获取左侧菜单栏
    setMenu(menus){
      if(!menus || typeof menus.map !== 'function'){
        this.menuList = [];
        return
      }
      console.log(menus)
      this.menuList = menus.map(item => {
        if (this.$router.history.current.query.lang !== "en"){
          item.menu_name = item.menu_cn_name;
          if(!item.sub_menus){
            item.sub_menus = [];
          }
          item.sub_menus = item.sub_menus.map(subItem => {
            subItem.menu_name = subItem.menu_cn_name;
            return subItem
          })
          return item
        } 
        return item
      })
      let sub  = "";
      // 根据URL确定该URL对应的 菜单的key
      for(let subKey in this.menuInfo.sub){
        if(this.menuInfo.sub[subKey] === this.$route.fullPath.split("?")[0]){
          sub  = subKey;
        }
      }
      if (sub === ""){
        return;
      }
      //根据菜单的key确定菜单的name (国际化)
      for(let i=0; i < this.menuList.length; i++){
        for(let j=0; j< this.menuList[i].sub_menus.length; j++){
          if (this.menuList[i].sub_menus[j].menu_key === sub) {
            this.menuName = this.menuList[i].sub_menus[j].menu_name;
            return;
          }
        }
      }
    },
    // 更换体系
    changeUserSys(newSys){
      if(typeof newSys !== "string"){
        console.error("Error sys");
        return
      }
      this.user_sys = newSys;
    },
    // 更换数据库
    changeDatabase(newData){
      if(typeof newData !== "string"){
        console.error("Error sys");
        return
      }
      this.user_database = newData;
    },
    // 切换正再选择的菜单名字
    clickMenu (name){
      this.menuName = name;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  computed: {
    // 城市选择options [根据所选国家]
    provinces(){
      if(!this.modalData.Form.country){
        return []
      }
      const country = this.countrys.filter(i => i.name === this.modalData.Form.country)
      if(country.length === 0){
        return []
      }
      return country[0].states
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("inst_info_2"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          placeholder: this.$I18n('inst_info_3'),
        },{
          label   : this.$I18n("sector"),
          keys    : "industry",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.$Param.industrySelect.map(i => {
            return {
              id  : this.$I18n(i.name),
              name: this.$I18n(i.name),
            }
          }),
        },{
          label   : this.$I18n("size_of_staff"),
          keys    : "scale",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.$Param.scaleSelect.map(i => {
            if(i.is_i18n){
              return {
                id  : this.$I18n(i.name),
                name: this.$I18n(i.name),
              }
            }
            return {
              id  : i.name,
              name: i.name,
            }
          })
        },{
          label   : this.$I18n("country_area"),
          keys    : "country",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.countrys.map(i => {
            return {
              id  : i.name,
              name: i.name,
            }
          }),
        },{
          label   : this.$I18n("full_addr"),
          keys    : "addr",
          type    : "input",
          placeholder: this.$I18n('pls_enter'),
        },{
          label   : this.$I18n("inst_info_9"),
          keys    : "icon",
        }
      ]
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
    this.getOrgani();
  },
  watch: {
    /////  需要恢复
    // "$root.state.apiurl":{
    //   handler(){
    //     this.getMenu().then(() => {
    //       let urlList = [];
    //       if(this.menuList){
    //         this.menuList.forEach(main => {
    //           if(main.sub_menus){
    //             main.sub_menus.forEach(sub => {
    //               urlList.push(menu.sub[sub.menu_key]);
    //             })
    //           }
    //         })
    //       }
    //       if(!urlList.includes(this.$router.history.current.path) && this.$router.history.current.path !== "/home"){
    //         this.$router.push({
    //           path : "/home",
    //           query: this.$router.history.current.query,
    //         })
    //       }
    //     })
    //     return 
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    sel_organi(newValue){
      const newUserInfo = this.organi.filter(i => i.name === newValue)
      if(newUserInfo.length > 0){
        this.$setUserInfo(newUserInfo[0])
        this.setMenu(newUserInfo[0].sys_menus)
      }
    },
    'modalData.Form.country':{
      handler(){
        this.modalData.Form.province = "";
        return 
      },
      immediate: true,
      deep: true,
    },
    menuList(newValue){
      if(newValue && newValue.length > 0){
        newValue.forEach(i => {
          if(!this.menuInfo.main[i.menu_key]){
            this.menuInfo.main[i.menu_key] = {
              icon : "settings",
            }
          }
        })
      }
    },
    '$router.history.current.query':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
  created () {},
};
</script>
<style lang="scss">
.menu-custom-icon{
  width: 22px;
  margin:2px 15px 2px 2px;
  float: left;
}

$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.diy-body{
  max-height: calc( 100vh - 72px);
  overflow-y: auto;
  // padding-bottom: 10px !important;
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.modal-load-icon{
  color: #00bcd4 !important;
  font-size: 100px !important;
  display: inline-block;
  line-height: 100px;
}
</style>
